import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import addCategoriesReducer from 'store/app/reducer/addCategoriesReducer';
import setCategoriesReducer from 'store/app/reducer/setCategoriesReducer';
import setCurrentPageParamsReducer from 'store/app/reducer/setCurrentPageParamsReducer';
import setCustomerDeviceTypeReducer from 'store/app/reducer/setCustomerDeviceTypeReducer';
import setIsLoggedInReducer from 'store/app/reducer/setIsLoggedInReducer';
import setLocaleReducer from 'store/app/reducer/setLocaleReducer';
import setOpRoutesReducer from 'store/app/reducer/setOpRoutesReducer';
import showBackdropReducer from 'store/app/reducer/showBackdropReducer';
import { AppState, CustomerDeviceScreenSize, CustomerDeviceType } from 'store/app/types';
import hidePopupReducer from './reducer/hidePopupReducer';
import nextStepFlowReducer from './reducer/nextStepFlowReducer';
import registerFlowReducer from './reducer/registerFlowReducer';
import setConfigurationReducer from './reducer/setConfigurationReducer';
import setEnvReducer from './reducer/setEnvReducer';
import setInitialURLReducer from './reducer/setInitialURLReducer';
import setTrustpilotDataReducer from './reducer/setTrustpilotDataReducer';
import setWaitingForNetworkReducer from './reducer/setWaitingForNetworkReducer';
import showPopupReducer from './reducer/showPopupReducer';
import addPopupReducer from './reducer/addPopupReducer';
import removePopupReducer from './reducer/removePopupReducer';

export const appInitialState: AppState = {
  locale: 'en-GB',
  categories: [],
  isLoggedIn: false,
  currentPageParams: {},
  initialURL: '',
  initialData: {},
  env: 'dev',
  customerDeviceType: CustomerDeviceType.DESKTOP,
  customerDeviceVerticallyOriented: false,
  customerDeviceScreenSize: CustomerDeviceScreenSize.LG,
  opRoutes: [],
  isBackdropVisible: false,
  isWaitingForNetwork: false,
  configuration: [],
  flows: {},
  trustpilot: undefined,
  addingOpPlusToBasket: false,
  addingProductToBasket: false,
  popups: [],
};

export const slice = createSlice({
  name: 'app',
  initialState: appInitialState,
  reducers: {
    setLocaleAction: setLocaleReducer,
    setCategoriesAction: setCategoriesReducer,
    addCategoriesAction: addCategoriesReducer,
    setIsLoggedInAction: setIsLoggedInReducer,
    setCurrentPageParamsAction: setCurrentPageParamsReducer,
    setOpRoutesAction: setOpRoutesReducer,
    showBackdropAction: showBackdropReducer,
    setCustomerDeviceTypeAction: setCustomerDeviceTypeReducer,
    setEnvAction: setEnvReducer,
    showPopupAction: showPopupReducer,
    hidePopupAction: hidePopupReducer,
    addPopupAction: addPopupReducer,
    removePopupAction: removePopupReducer,
    setConfigurationAction: setConfigurationReducer,
    registerFlowAction: registerFlowReducer,
    nextStepFlowAction: nextStepFlowReducer,
    setInitialURLAction: setInitialURLReducer,
    setWaitingForNetworkAction: setWaitingForNetworkReducer,
    setTrustpilotDataAction: setTrustpilotDataReducer,
    setAddingOpPlusToBasketAction: (state: AppState, action: PayloadAction<boolean>) => {
      state.addingOpPlusToBasket = action.payload;
    },
    setAddingProductToBasketAction: (state: AppState, action: PayloadAction<boolean>) => {
      state.addingProductToBasket = action.payload;
    },
  },
});

export const {
  setLocaleAction,
  setCategoriesAction,
  addCategoriesAction,
  setIsLoggedInAction,
  setCurrentPageParamsAction,
  setOpRoutesAction,
  showBackdropAction,
  setCustomerDeviceTypeAction,
  setEnvAction,
  showPopupAction,
  hidePopupAction,
  addPopupAction,
  removePopupAction,
  setConfigurationAction,
  registerFlowAction,
  nextStepFlowAction,
  setInitialURLAction,
  setWaitingForNetworkAction,
  setTrustpilotDataAction,
  setAddingOpPlusToBasketAction,
  setAddingProductToBasketAction,
} = slice.actions;

const app = slice.reducer;
export default app;
